<template>
  <div id="page">
    <!-- all_in -->
    <!-- <div class="break_box">
      <Breadcrumb>
        <breadcrumbs></breadcrumbs>
      </Breadcrumb>
    </div> -->
    <div class="con_all" v-if="!$route.meta.keepAliveSub">
      <div class="con_box2">
        <div v-html="(Page.title)" style="margin-bottom: 40px;margin-left: -10px;"></div>
        <div class="content" v-html="allContent"></div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'page',
  data() {
    return {
      PageLink: this.$route.params.pageName,
      Page: {},
      language: sessionStorage.getItem('locale'),

    };
  },
  created() {
    this.init();

  },
  watch: {
    '$route' (to, from) {
      this.PageLink = this.$route.params.pageName
      this.init();
    }
  },
  computed: {
    allContent() {
      if (typeof this.Page.context !== "undefined") {
        return JSON.parse(this.Page.context).map(item => {
          return (item.content)
        }).join('<br><br>')
      }
    }
  },
  methods: {
    init() {
      this.initPage();
    },
    initPage() {
      this.getPageData();
    },
    getPageData() {
      axios.get(API.webpage + `?linkUrl=${this.PageLink}&language=${this.language}`)
        .then(response => {
          response.data = response.data.filter(data => {
            return data.trash !== 1;
          })
          if (response.data[0]) {
            this.Page = response.data[0];
          } else {

            this.$router.push({ name: '404' })
            return false
          }
        })
        .then(() => {
          document.title = sessionStorage.locale === 'CH' ? this.Page.menuTitleCh : this.Page.menuTitleEn
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },


  },
}

</script>
<style lang="scss">
#page {
  a {
    color: #11574F;
  }
}

</style>



// WEBPACK FOOTER //
// Page.vue?2c68da3c